export default "/fonts/enchanted_land-webfont.woff2?b8436b0d0f15d6c720b710fea8350427";